export const ADMINSTRATIVE_FEE = 5;
export const PER_GAME_FEE = 5
export const ENTRY_FEE = PER_GAME_FEE * 15;
export const SEASON_ENTRY_FEE = ENTRY_FEE + ADMINSTRATIVE_FEE;